import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmergencyShareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emergency_share"}/>
}
